/**
 * 全局常量配置
 * 统一管理应用中的常量数据
 */

// Generator 组件 - 时长选项
export const DURATIONS = [
  { value: 30, text: '30s' },
  { value: 45, text: '45s' },
  { value: 60, text: '60s' },
  { value: 90, text: '90s' },
];

// Generator 组件 - 灵感标签
export const INSPIRATION_TAGS = {
  en: ['Valentine Monologue', 'Year of the Horse', 'Tribute to Heroes', 'Cyber Night', 'Youth Farewell'],
  zh: ['情人节独白', '马年大吉', '致敬平凡英雄', '赛博夜色', '青春散场']
};

// FilmStrip 组件 - 故事卡片
export const STORY_CARDS = [
  { id: 1, image: './pic/story1.jpg', tags: { en: '#Passion', zh: '#激情' } },
  { id: 2, image: './pic/story2.jpg', tags: { en: '#Dream', zh: '#梦想' } },
  { id: 3, image: './pic/story3.jpg', tags: { en: '#Health', zh: '#健康' } },
  { id: 4, image: './pic/story4.jpg', tags: { en: '#Struggle', zh: '#奋斗' } },
  { id: 5, image: './pic/story5.jpg', tags: { en: '#Reunion', zh: '#团聚' } },
  { id: 6, image: './pic/story6.jpg', tags: { en: '#Romance', zh: '#浪漫' } },
];

// Showcase 组件 - 视频模板
export const VIDEO_TEMPLATES = [
  {
    id: 1,
    image: './pic/neon.jpg',
    titles: { en: 'Neon Dream', zh: '《霓虹幻梦》' },
    author: '@CyberArtist',
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=500&q=80',
    titles: { en: 'Heartfelt Confession', zh: '《深情告白》' },
    author: '@LoveStory',
  },
  {
    id: 3,
    image: './pic/rock.jpg',
    titles: { en: 'Rock Night', zh: '《摇滚之夜》' },
    author: '@RockStar',
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=500&q=80',
    titles: { en: 'Distant Home', zh: '《远方的家》' },
    author: '@Traveler',
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=500&q=80',
    titles: { en: 'Light and Shadow', zh: '《光影流年》' },
    author: '@OldSchool',
  },
];

// 本地存储键名
export const STORAGE_KEYS = {
  USER: 'mvme_user',
  TOKEN: 'mvme_token'
};

// API 端点
export const API_ENDPOINTS = {
  BASE_URL: 'http://localhost:5000',
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  FORGOT_PASSWORD: '/api/auth/forgot-password',
  GOOGLE_AUTH: '/auth/google',
  ME: '/api/auth/me'
};

// 支持的语言
export const LANGUAGES = {
  EN: 'en',
  ZH: 'zh'
};

// 登录视图模式
export const LOGIN_VIEWS = {
  CHOICE: 'choice',
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOT: 'forgot'
};
